import React from 'react';

import type { GroupedOption } from '@common_components/inputs/selects/selectInput.component';
import { ChartSectionList } from 'components/inputs/chartSectionListContainer.component';
import type { ChartSection, ChartSectionListHandle } from 'components/inputs/chartSectionList.interfaces';

interface ChartSectionsSectionProps {
  chartSections: ChartSection[];
  setChartSections: ( sections: ChartSection[] ) => void;
  chartUnitOptions: GroupedOption[];
  managerOptions: GroupedOption[];
  themeOptions: GroupedOption[];
  defaultChartSettingManagerId: string;
  defaultChartSettingUnitId: string | null;
  chartSectionListRef: React.Ref<ChartSectionListHandle>;
  onPendingChartSettingsChange: ( hasPending: boolean ) => void;
  eventManagerId: string;
}

const ChartSectionsSection: React.FC<ChartSectionsSectionProps> = ( {
  chartSections,
  setChartSections,
  chartUnitOptions,
  managerOptions,
  themeOptions,
  defaultChartSettingManagerId,
  defaultChartSettingUnitId,
  chartSectionListRef,
  onPendingChartSettingsChange,
  eventManagerId,
} ) => {
  return (
    <ChartSectionList
      ref={ chartSectionListRef }
      sections={ chartSections }
      onChange={ setChartSections }
      labelPosition='top'
      chartUnitOptions={ chartUnitOptions }
      managerOptions={ managerOptions }
      themeOptions={ themeOptions }
      defaultManagerId={ defaultChartSettingManagerId }
      defaultChartUnitId={ defaultChartSettingUnitId }
      onPendingSettingsChange={ onPendingChartSettingsChange }
      eventManagerId={eventManagerId}
    />
  );
};

export default ChartSectionsSection;
